export default __webpack_public_path__ + "static/media/AKM_4.949b24ca.png";